import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation SurveyNavigatorAnswer(
    $ticket_id: ID
    $question_id: ID!
    $user_id: ID
    $answers: [SurveyAnswerInput]!
  ) {
    surveyNavigatorAnswer(
      ticket_id: $ticket_id
      question_id: $question_id
      user_id: $user_id
      answers: $answers
    ) {
      id
      answer_info(user_id: $user_id, ticket_id: $ticket_id) {
        updated_at
        responder {
          full_name
        }
      }
      answers {
        nodes {
          id
          title
          kind
          answer_value(user_id: $user_id, ticket_id: $ticket_id)
          unblocks_answer_id
          blocked_by_default
        }
      }
    }
  }
`

export default function useSurveyNavigatorAnswer() {
  const { onMutate: onSurveyNavigatorAnswer, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'surveyNavigatorAnswer',
    successMessage: 'Question updated'
  })
  return { onSurveyNavigatorAnswer, loading }
}
